export enum CalendarEvents {
  DATE_TO_CHANGED = 'dateToChanged',
  DATE_FROM_CHANGED = 'dateFromChanged',
  SELECTED_RANGE_CONFIRMED = 'selectedRangeConfirmed',
  SELECTED_RANGE_CANCELLED = 'selectedRangeCancelled',
  HOVERED_DATE_CHANGED = 'hoveredDateChanged',
  DATE_IS_SELECTED = 'dateIsSelected',
  DATE_IS_HOVERED = 'dateIsHovered',
  YEAR_CHANGED = 'yearChanged',
  NEXT_MONTH = 'nextMonth',
  PREV_MONTH = 'prevMonth',
  CUSTOM_HOURS_CHANGED = 'customHoursChanged',
  CUSTOM_DATE_CHANGED = 'customDateChanged',
}

export const DATE_FORMAT = 'dd/MM/yyyy';
export const CUSTOM_TIME_RANGE_VALUE = 'custom';
export const All_TO_DATE_RANGE_VALUE = 'allToDate';
export const FROM_TIMESTAMP_ID = 'fromTimestamp';
export const TO_TIMESTAMP_ID = 'toTimestamp';

export interface DateRangePickerInputs {
  day: string;
  hours: number | undefined;
  minutes: number | undefined;
  seconds: number | undefined;
}

export interface DateRangePickerTranslateStrings {
  confirmButton: string;
  cancelButton: string;
  fromLabel: string;
  toLabel: string;
}
